export const profileSelectors = {
  nameSelector: '.profile__name',
  jobSelector: '.profile__job',
  avatarSelector: '.avatar__photo'
};

export const configValidate = {
  formSelector: '.popup__form_validated',
  inputSelector: '.popup__input',
  submitButtonSelector: '.popup__btn-submit',
  inactiveButtonClass: 'popup__btn-submit_disabled',
  inputErrorClass: 'popup__input_type_error'
};

export const listCardSelector = '.cards__grid';
export const profileBtnAdd = document.querySelector('.profile__btn-add');
export const profileBtnEdit = document.querySelector('.profile__btn-edit');
export const avatar = document.querySelector('.avatar');